var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.49 58.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a849ae81-8ab4-4cde-9c1c-b38171b532fa,.efea0a76-e99d-4eb3-a84a-5b4fb243dfc3{fill:none;stroke:#1a1a1a;stroke-miterlimit:10;}.a849ae81-8ab4-4cde-9c1c-b38171b532fa{stroke-width:1.27px;}.efea0a76-e99d-4eb3-a84a-5b4fb243dfc3{stroke-width:0.73px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "acd14aad-b7d1-4ed9-89f3-01f0823568e2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bce4f438-22c1-4117-a70a-61d1103e7aff",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a849ae81-8ab4-4cde-9c1c-b38171b532fa",
    cx: 29.24,
    cy: 29.24,
    r: 28.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "efea0a76-e99d-4eb3-a84a-5b4fb243dfc3",
    d: "M46.87,36.82v1.34a1.37,1.37,0,0,1-1.39,1.35H14.88a2.74,2.74,0,0,1-2.78-2.69V19.9a2.73,2.73,0,0,1,2.78-2.68h30.6a1.36,1.36,0,0,1,1.39,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "efea0a76-e99d-4eb3-a84a-5b4fb243dfc3",
    d: "M37.34,28.1c2.56,0,3.18-2,3.18-3.72a3.19,3.19,0,0,0-6.37,0c0,1.69.85,3.72,3.19,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "efea0a76-e99d-4eb3-a84a-5b4fb243dfc3",
    d: "M37.78,28.52h-.89c-1.74,0-4.36,1.55-4.36,3.45s-.59,3.45,1.16,3.45H41c1.74,0,1.15-1.54,1.15-3.45s-2.62-3.45-4.36-3.45Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "efea0a76-e99d-4eb3-a84a-5b4fb243dfc3",
    x1: 16.24,
    y1: 21.85,
    x2: 29.48,
    y2: 21.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "efea0a76-e99d-4eb3-a84a-5b4fb243dfc3",
    x1: 16.24,
    y1: 25.88,
    x2: 29.48,
    y2: 25.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "efea0a76-e99d-4eb3-a84a-5b4fb243dfc3",
    x1: 16.24,
    y1: 29.91,
    x2: 29.48,
    y2: 29.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "efea0a76-e99d-4eb3-a84a-5b4fb243dfc3",
    x1: 16.24,
    y1: 33.94,
    x2: 29.48,
    y2: 33.94
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIcon);
export default __webpack_public_path__ + "static/media/ic_icon.0ad65bb903b66ff08cc2d2cf9ee46e99.svg";
export { ForwardRef as ReactComponent };